import React from 'react'
import { Cell, Grid, Button, FontIcon } from 'react-md'
import { Field, reduxForm } from 'redux-form'

import { Recaptcha, TextField } from 'components'
import {
  required,
  email,
  minLength,
  maxLength,
  mediumPassword,
  strongPassword
} from 'lib/validation'

import './index.css'

const minLength2 = minLength(2)
const minLength8 = minLength(8)
const maxLength30 = maxLength(30)
const maxLength50 = maxLength(50)

const SignUpForm = ({ form, handleSubmit, recaptchaRef }) => (
  <form onSubmit={handleSubmit}>
    <Grid>
      <Cell size={12}>
        <Field
          id={`${form}-first-name`}
          name='firstName'
          label='First name'
          minLength={2}
          maxLength={30}
          placeholder='Please enter your first name'
          helpText={`Your name won't be displayed online`}
          component={TextField}
          validate={[ required, minLength2, maxLength30 ]}
          required
        />
      </Cell>
      <Cell size={12}>
        <Field
          id={`${form}-last-name`}
          name='lastName'
          label='Last name'
          minLength={2}
          maxLength={30}
          placeholder='Please enter your last name'
          helpText={`Your name won't be displayed online`}
          component={TextField}
          validate={[ required, minLength2, maxLength30 ]}
          required
        />
      </Cell>
      <Cell size={12}>
        <Field
          id={`${form}-artist-name`}
          name='artisticName'
          label='Artist name'
          minLength={2}
          maxLength={30}
          placeholder='E.g. Andy Warhol, Banksy'
          component={TextField}
          validate={[ required, minLength2, maxLength30 ]}
          helpText='This will be displayed online and cannot be changed later'
          required
        />
      </Cell>
      <Cell size={12}>
        <Field
          id={`${form}-email`}
          name='email'
          label='Email'
          placeholder='Enter your email'
          component={TextField}
          validate={[ required, email ]}
          helpText='Make sure you use an email you can access'
          required
        />
      </Cell>
      <Cell size={12}>
        <Field
          id={`${form}-password`}
          name='password'
          label='Password'
          placeholder='Enter your password'
          type='password'
          component={TextField}
          validate={[ required, minLength8, maxLength50, mediumPassword ]}
          warn={[ strongPassword ]}
          helpText='Must contain at least 8 characters'
          required
        />
      </Cell>
      <Cell size={12} className='captcha'>
        <Field
          name='captcha'
          component={Recaptcha}
          inputRef={recaptchaRef}
        />
      </Cell>
      <Cell size={12} className='signup-footer md-text-center'>
        <Button
          type='submit'
          flat
          primary
          swapTheming
          className='join-button'
        >
          Continue
        </Button>
        <div className='signup-terms'>
          <p className='md-caption'>
            By creating an account, you are agreeing to our Terms of Service.
          </p>
        </div>
        <div className='signup-secure'>
          <FontIcon forceSize={12} forceFontSize secondary>lock</FontIcon>
          <span className='md-caption'>Your information is secure.</span>
        </div>
      </Cell>
    </Grid>
    <button type='submit' style={{display: 'none'}} />
  </form>
)

export default reduxForm({ form: 'signup' })(SignUpForm)



// WEBPACK FOOTER //
// ./src/containers/Home/SignUp/index.js